export default "/react/target-group-75fc7294.svg";